package org.teddapp.project.db

import kotlin.random.Random

internal fun newId(prefix: String): String {
    val suffix = buildString {
        repeat(8) { append(ALPHABET[Random.nextInt(ALPHABET.size)]) }
    }
    return "${prefix}_$suffix"
}

private val ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789".toCharArray()

/** Un UUID v4 en minuscules, comme le noyau en donne à ses faits. */
@OptIn(kotlin.uuid.ExperimentalUuidApi::class)
internal fun randomUuid(): String = kotlin.uuid.Uuid.random().toString()

internal expect fun nowMillis(): Long

/**
 * Date du jour ISO (YYYY-MM-DD), évaluée à chaque accès depuis [nowMillis].
 * Implémentation purement Kotlin (algorithme Howard Hinnant "civil_from_days")
 * — pas de dépendance kotlinx-datetime. Les bornes sont calculées en UTC ;
 * acceptable tant que les utilisateurs sont en UTC±0 (Afrique de l'Ouest).
 */
val TODAY_ISO: String
    get() {
        val days = (nowMillis() / 86_400_000L).toInt()
        val (y, m, d) = civilFromDays(days)
        return "${y.toString().padStart(4, '0')}-" +
            "${m.toString().padStart(2, '0')}-" +
            "${d.toString().padStart(2, '0')}"
    }

/**
 * Convertit un nombre de jours depuis l'époque (1970-01-01) en triplet (année, mois, jour).
 * Algorithme exact, valide sur toute la fenêtre proleptique grégorienne.
 */
internal fun civilFromDays(z: Int): Triple<Int, Int, Int> {
    val shifted = z + 719468L
    val era = if (shifted >= 0) shifted / 146097L else (shifted - 146096L) / 146097L
    val doe = shifted - era * 146097L                       // [0, 146096]
    val yoe = (doe - doe / 1460L + doe / 36524L - doe / 146096L) / 365L
    val yAdj = yoe + era * 400L
    val doy = doe - (365L * yoe + yoe / 4L - yoe / 100L)    // [0, 365]
    val mp = (5L * doy + 2L) / 153L                         // [0, 11]
    val d = (doy - (153L * mp + 2L) / 5L + 1L).toInt()      // [1, 31]
    val m = (if (mp < 10L) mp + 3L else mp - 9L).toInt()
    val y = (yAdj + if (m <= 2) 1L else 0L).toInt()
    return Triple(y, m, d)
}